<template>
  <div>
    <b-modal
      size="md"
      no-fade
      id="modal-cotacao"
      no-close-on-esc
      no-close-on-backdrop
      title="Cotação"
    >
      <b-row>
        <b-col sm="4" md="4" lg="4">
          <b-form-group label-size="sm" label="Moeda" label-for="moeda_id">
            <v-select
              id="moeda_id"
              :disabled="action === 'view'"
              :options="combos.moedas"
              label="sigla"
              :reduce="m => m.moeda_id"
              :clearable="false"
              v-model="quote.moeda_id"
            >
              <template v-slot:option="option">{{ `${option.sigla}`}}</template>
              <template v-slot:selected-option="option">{{ `${option.sigla}`}}</template>
              <template #no-options="{}">Sem dados a serem exibidos</template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col sm="4" md="4" lg="4">
          <b-form-group label="Data" label-size="sm" label-for="dt_cotacao">
            <date-picker
              required
              input-class="form-control form-control-sm"
              :disabled="action === 'view'"
              :clearable="false"
              maxlength="10"
              format="DD/MM/YYYY"
              value-type="format"
              v-model="quote.dt_cotacao"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col sm="4" md="4" lg="4">
          <b-form-group label="Cotação" label-size="sm" label-for="vl_cotacao">
            <b-form-input
              size="sm"
              ref="vl_cotacao"
              id="vl_cotacao"
              maxlength="20"
              v-model="quote.vl_cotacao"
              :disabled="action === 'view'"
              trim
              type="text"
              required
              v-mask="{ alias: 'numeric', autoUnmask: true, greedy: true, radixPoint: ',', groupSeparator: '.', digits: 4, digitsOptional: false, autoGroup: true, allowPlus: false, allowMinus: false, onUnMask: function (maskedValue) { var x = maskedValue.split(','); return x[0].replace(/\./g, '') + '.' + x[1]; }}"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-button v-if="action !== 'view'" size="sm" @click="saveRecord()" variant="primary">
          <i class="fas fa-check"></i> Gravar
        </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-cotacao')">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import axios from "axios";
import { baseApiUrl, showError, formatDate } from "@/global";

export default {    
  name: "ModalCurrenyQuote",
  components: { DatePicker },
  props: {
    quote: { type: Object, required: true },
    action: { type: String, required: true, default: "view" },
  },
  data: function () {
    return {
      combos: {
        moedas: [],
      },
    };
  },
  methods: {
    validateRecord() {
      let _msg = "";
      //if ((this.quote.vl_cotacao || "") === "") _msg = "Informe a Descrição";

      if (_msg !== "") {
        this.$toasted.info(_msg, {
          duration: 4000,
          keepOnHover: true,
          className: "v-toasted-warning",
        });
         return false;
      }
      return true;
    },
    saveRecord() {
      if (!this.validateRecord()) return;

      let _saveObj = { ...this.quote };
      _saveObj.dt_cotacao = formatDate(
        _saveObj.dt_cotacao,
        "DD/MM/YYYY",
        "YYYY-MM-DD"
      );


      if (this.action === "new") {
        axios
          .post(`${baseApiUrl}/bid/cotacoes`, _saveObj)
          .then(() => {
            this.$bvModal.hide("modal-cotacao");
            this.$emit("updated");
          })
          .catch((err) => {
            showError(err);
          });
      } else {
        axios
          .put(`${baseApiUrl}/bid/cotacoes`, _saveObj)
          .then(() => {
            this.$bvModal.hide("modal-cotacao");
            this.$emit("updated");
          })
          .catch((err) => {
            showError(err);
          });
      }
    },
    loadCombos() {
      // moedas
      axios
        .get(`${baseApiUrl}/bid/moedas`)
        .then((resp) => {
            resp.data.splice(0, 1);
          this.combos.moedas = resp.data;
        })
        .catch(showError);
    },
  },
  mounted() {
    this.loadCombos();
  },
};
</script>

<style>
    .mx-datepicker{
        width: 100% !important;
    }
</style>